<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="1100px"
    :title="$l('dialog_choose_user_title') || '选择人员'"
    :close-on-click-modal="false"
    :before-close="close"
    append-to-body
    v-el-dialog-drag
  >
    <PageMain
      :loading="loading"
      :tableData="tableData"
      :tablePage="page"
      @chooseChange="chooseChange"
    >
      <template #header>
        <PageHeader
          ref="header"
          :checkedCount="checkedCount"
          @query="getData"
          @reset="resetPage"
        />
      </template>
      <template #pager>
        <pagination
          size="small"
          align="right"
          :current-page="page.curPage"
          :page-size="page.pageSize"
          :page-total="page.pageTotal"
          @change="handlePaginationChange"
        />
      </template>
    </PageMain>
    <span slot="footer">
      <el-button size="small" @click="close">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        :disabled="!checkedCount"
        @click="confirm"
      >
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import BaseTable from '@/mixins/base-table'
import PageHeader from './header.vue'
import PageMain from './main.vue'

export default {
  components: { PageHeader, PageMain },
  mixins: [BaseTable],
  props: {
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      usePage: true,
      checkedRows: [],
    }
  },
  computed: {
    checkedCount() {
      return this.checkedRows.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .sysUserList({
          ...form,
          ...this.page,
          userStatusList: ['Y'],
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    chooseChange(rows) {
      this.checkedRows = rows
    },
    confirm() {
      if (!this.checkedRows.length) return

      this.$emit('confirm', this.checkedRows)
      this.close()
    },
    close() {
      this.checkedRows = []
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
